import React, { Component } from "react";
import ReactTable from "react-table";
import ClearfixChildren from 'components/Custom/ClearfixChildren';
import { utils, delay } from '../../helpers';
import {
    FormGroup,
    Label,
    Input
} from "reactstrap";
import { withTranslation } from 'react-i18next';

// Nota: jQuery è stato aggiunto per non selezionare il testo quando le righe vengono selezionate
//       tenendo premuto il tasto Shift.
import $ from 'jquery';
window.$ = $;

class ReactAJAXTable extends Component {

    constructor(props) {
        super(props)

        this.onFetchData = this.onFetchData.bind(this)
        this.getTrProps = this.getTrProps.bind(this)
        this.onChangeSelectedRow = this.onChangeSelectedRow.bind(this)
        this.onChangeCurrentPageRowsSelected = this.onChangeCurrentPageRowsSelected.bind(this)
        this.onChangeAllCurrentlyFilteredRowsSelected = this.onChangeAllCurrentlyFilteredRowsSelected.bind(this)
        this.onSelectedRowsMapChangedCallback = this.onSelectedRowsMapChangedCallback.bind(this)

        this.state = {
            selectedRowsMap: {},
            currentPageIds: [],
            currentPageSelectedRanges: [],
            filtered: [],
            onFilteredChange: [],
            allFilteredChecked: false,
            filtersAreOutOfSync: false,
            /*
            * N.B.: `rerenderingJustTriggered` ha 3 stati:
            *       - null
            *       - false
            *       - true
            * 
            *       È importantissimo durante la sincronizzazione dello state della ReacTable e lo state di Redux
            *       perché a volte i due rimangono sfasati (quando l'utente digita troppo velocemente e ormai una
            *       AJAX è partita sul server).
            */
            rerenderingJustTriggered: null,
            filtersObj: null,
            lastToggledId: null,
            selectedIdsStack: [],
            allFilteredItemsNoLimit: [],
            triggeringOnChangeSelectedItemsListener: false,
            filtered_count: 0,
            pages: 0,
            limit: 10
        }
    }

    buildFilters(obj, filtersAdapter, customizer) {
        return filtersAdapter(obj,customizer)
    }

    performDataFetching(filtersToUse) {
        const { dispatch, actionCreator, selectableRows } = this.props
        const filters = utils.cloneDeeply(filtersToUse)
        const options = {
            filters,
            next: (filters, dispatch) => {
                // next
                dispatch(actionCreator.filter(filters))
            }
        }

        let invoke = (options, filters, dispatch) => {

           return (
                (
                    this.props.actionCreatorOverride
                    &&
                    this.props.actionCreatorOverride(filters)
                )
                ||
                actionCreator.filterCount(options)
            )
        }
        if (selectableRows && !this.props.actionCreatorOverride) {
            const currentInvoke = invoke
            invoke = (options, filters, dispatch) => {
                return actionCreator.filterAllNoLimit({
                    filters,
                    next: () => {
                        dispatch(currentInvoke(options, filters, dispatch))
                    }
                })
            }
        }

        dispatch(
            invoke(options, filters, dispatch)
        );
    }

    onFetchData(state, instance) {

        const { filters: propsFilters, AJAXAdapter, filtersCustomizer } = this.props

        // console.log('onFetchData',this.props);
        if (this.props.loading){
            return;
        }

        let obj = {
            page: state.page,
            pageSize: state.pageSize,
            sorted: state.sorted,
            filtered: state.filtered
        }
        const filters = this.buildFilters(obj, AJAXAdapter, filtersCustomizer)

        const performDataFetching = () => {
            console.log('performDataFetching');
            this.setState({
                lastToggledId: null,
                selectedIdsStack: [],
                filters: utils.cloneDeeply(filters),
                filtered: state.filtered,
                filtersObj: obj
            }, () => {
                this.performDataFetching(this.state.filters)
            })
        };

        // Setto un delay se ho una where perché l'utente potrebbe digitare velocemente.
        if (filters.where) {
            // Devo anche identificare se la where è cambiata...
            // Se non cambia, no delay.
            let doDelay = false

            let recordsFiltersWhere = propsFilters && propsFilters.where
            if (recordsFiltersWhere) {
                if (!utils.deepObjectCompare(filters.where, recordsFiltersWhere)) {
                    doDelay = true
                }
            }
            else {
                doDelay = true
            }
            if (doDelay) {
                delay(performDataFetching, 300)
                return
            }
        }

        performDataFetching()
    }

    isRowSelected(rowInfo) {
        const idField = this.getIdField()
        const idValue = rowInfo.original[idField]
        return this.state.selectedRowsMap[idValue]
    }

    getIdField() {
        return this.props.idField || 'id'
    }

    getTrProps(state, rowInfo) {
        if (!rowInfo) {
            // rowInfo può essere undefined perché viene chiamata più volte.
            return {}
        }
        return {
            onClick: (e) => {
                if (
                    (e.ctrlKey || e.metaKey || e.shiftKey)
                    &&
                    // La checkbox che seleziona la riga ha dentro uno span che trigghera questo listener prima
                    // del listener che cambia lo stato della checkbox!
                    !e.target.classList.contains('form-check-sign')
                ) {
                    this.onChangeSelectedRow(e, rowInfo)
                }
            },
            style: {
                ...(
                    this.isRowSelected(rowInfo)
                        ?
                        {
                            background: (this.props.selectedRowColor || '#ceedd4')
                        }
                        :
                        {}
                )
            }
        }
    }

    onChangeCurrentPageRowsSelected(e) {
        const checked = e.target.checked
        const nextStateSelectedRowsMap = this.getAllCurrentPageRowsSelectedMapState(checked)

        const nextState = {}
        nextState.currentPageSelectedRanges = []

        console.log('onChangeCurrentPageRowsSelected');
        this.setState({
            ...nextState,
            selectedRowsMap: {
                ...(this.state.selectedRowsMap),
                ...nextStateSelectedRowsMap
            },
            lastToggledId: !checked ? null : this.state.lastToggledId,
            ...(
                this.state.allFilteredChecked && !checked ?
                    {
                        allFilteredChecked: false
                    }
                    :
                    {}
            )
        }, this.onSelectedRowsMapChangedCallback)
    }

    onChangeAllCurrentlyFilteredRowsSelected(e) {
        const checked = e.target.checked

        const nextState = {}

        const copy = {}

        const ids = Object.keys(this.state.selectedRowsMap)
        for (const id of ids) {
            copy[id] = checked
        }

        nextState.selectedRowsMap = copy

        nextState.currentPageSelectedRanges = [];
        console.log('onChangeAllCurrentlyFilteredRowsSelected');
        this.setState({
            ...nextState,
            allFilteredChecked: checked,
            lastToggledId: !checked ? null : this.state.lastToggledId,
        }, this.onSelectedRowsMapChangedCallback)
    }

    getSelectedItems() {
        const allFilteredItemsNoLimit = this.state.allFilteredItemsNoLimit
        if (this.state.allFilteredChecked) {
            return allFilteredItemsNoLimit
        }
        else {
            const selectedIds = this.selectedIds()
            const selectedItems = []
            const idField = this.getIdField()
            for (const filteredItem of allFilteredItemsNoLimit) {
                const filteredItemId = filteredItem[idField]
                if (utils.includesTypeCoercion(selectedIds, filteredItemId)) {
                    selectedItems.push(filteredItem)
                }
            }
            return selectedItems
        }
    }

    onSelectedRowsMapChangedCallback(onStateChangedCallback) {
        const triggerOnChangeSelectedItemsListener = () => {
            if (
                !this.state.triggeringOnChangeSelectedItemsListener
                &&
                typeof this.props.onChangeSelectedItems === "function"
            ) {
                console.log('onSelectedRowsMapChangedCallback1');
                this.setState({
                    triggeringOnChangeSelectedItemsListener: true,
                }, () => {
                    this.props.onChangeSelectedItems(this.getSelectedItems())
                })
            }
        }

        console.log('onSelectedRowsMapChangedCallback2');
        this.setState({
            currentPageSelectedRanges: this.getCurrentPageSelectedRanges()
        }, typeof onStateChangedCallback === "function" ?
            () => {
                onStateChangedCallback()
                triggerOnChangeSelectedItemsListener()            
            }
            :
            () => {
                triggerOnChangeSelectedItemsListener()
            }
        )
    }

    getCurrentPageSelectedRanges() {
        const currentPageSelectedRanges = []
        let currentRangeIds = []
        let currentRangeStartId = null
        let previousSelectedId = null

        let i = 0
        for (const id of this.state.currentPageIds) {
            i++
            const selected = this.state.selectedRowsMap[id]
            if (selected) {
                if (currentRangeStartId === null) {
                    currentRangeStartId = id
                }

                if (i == this.state.currentPageIds.length) {
                    currentRangeIds.push(id)
                    currentPageSelectedRanges.push({
                        from: currentRangeStartId,
                        to: id,
                        ids: currentRangeIds
                    })
                    break;
                }
                else {
                    previousSelectedId = id
                    currentRangeIds.push(id)
                }
            }
            else {
                if (currentRangeStartId !== null) {
                    currentPageSelectedRanges.push({
                        from: currentRangeStartId,
                        to: previousSelectedId,
                        ids: currentRangeIds
                    })
                    currentRangeStartId = null
                    currentRangeIds = []
                }
            }
        }
        return currentPageSelectedRanges
    }

    mappedSelectedRowIds(currentPageIds, checked) {
        const mapped = {}
        for (const id of currentPageIds) {
            mapped[id] = checked
        }
        return mapped
    }

    getAllCurrentPageRowsSelectedMapState(checked) {
        const mapped = this.mappedSelectedRowIds(this.state.currentPageIds, checked)
        return {
            ...(mapped)
        }
    }

    isRowSelectedWithShiftKeyDirectionUp(previousId, currentId) {
        for (const id of this.state.currentPageIds) {
            if (id == previousId) {
                return false
            }
            else if (id == currentId) {
                return true
            }
        }
        return false
    }

    findCurrentPageSelectedRange(idValue, currentPageSelectedRanges) {
        for (const range of currentPageSelectedRanges) {
            const rangeIds = range.ids
            if (rangeIds.includes(idValue)) {
                return range
            }
        }
        return null
    }

    rowRangeIds(isDirectionUp, previousToggledRowId, idValue) {
        const ret = []
        let fromId = previousToggledRowId
        let toId = idValue
        if (isDirectionUp) {
            fromId = idValue
            toId = previousToggledRowId
        }

        let withinRange = false
        for (let i = 0; i < this.state.currentPageIds.length; i++) {
            const nthId = this.state.currentPageIds[i]
            if (nthId == fromId) {
                withinRange = true
                ret.push(nthId)
            }
            else if (nthId == toId) {
                withinRange = false
                ret.push(nthId)
            }
            else if (withinRange) {
                ret.push(nthId)
            }
        }
        return ret
    }

    onChangeSelectedRow(e, rowInfo) {
        e.stopPropagation()
        const idField = this.getIdField()
        const idValue = rowInfo.original[idField]
        let checked = !this.state.selectedRowsMap[idValue]
        if ("checked" in e.target) {
            checked = e.target.checked
        }

        const previousToggledRowId = this.state.lastToggledId
        const previousRowSelected = this.state.selectedRowsMap[previousToggledRowId]

        let forceCurrentValueAppendToSelectedIdsStack = false

        let nextState = {
            lastToggledId: idValue,
            ...(
                this.state.allFilteredChecked && !checked ?
                    {
                        allFilteredChecked: false
                    }
                    :
                    {}
            )
        }

        if (e.shiftKey
            &&
            (this.state.lastToggledId !== null)
            &&
            (this.currentPageSelectedRowsCount() > 0)
            &&
            (previousToggledRowId != idValue)
        ) {
            let isDirectionUp = this.isRowSelectedWithShiftKeyDirectionUp(previousToggledRowId, idValue)
            let rowRangeIds = this.rowRangeIds(isDirectionUp, previousToggledRowId, idValue)
            const currentPageSelectedRanges = this.state.currentPageSelectedRanges

            const selectedMap = {}

            const range = this.findCurrentPageSelectedRange(idValue, currentPageSelectedRanges)
            if (range) {
                const rangeFromId = range.from
                const rangeToId = range.to
                const rangeIds = utils.cloneArray(range.ids)

                // `rangeFromId` o `rangeToId` determinano determinano la direzione
                let idsToUnselect = []
                for (let i = 0; i < this.state.selectedIdsStack.length; i++) {
                    const selectedIdStacked = this.state.selectedIdsStack[i]
                    if (rangeFromId == selectedIdStacked) {
                        idsToUnselect = utils.arraySliceFromTo(rangeIds, idValue, rangeToId)
                        break
                    }
                    else if (rangeToId == selectedIdStacked) {
                        const clone = utils.cloneArray(rangeIds)
                        clone.reverse()
                        idsToUnselect = utils.arraySliceFromTo(clone, idValue, rangeFromId)
                        break
                    }
                }
                if (!idsToUnselect.length) {
                    idsToUnselect = utils.arraySliceFromTo(rangeIds, idValue, rangeToId)
                    if (!isDirectionUp) {
                        idsToUnselect = utils.arraySliceFromTo(rangeIds, rangeFromId, idValue)
                    }
                }
                for (const idToUnselect of idsToUnselect) {
                    selectedMap[idToUnselect] = false
                }
            }
            else {
                if (checked) {
                    if (previousRowSelected) {
                        for (const rangeId of rowRangeIds) {
                            selectedMap[rangeId] = true
                        }
                    }
                    else {
                        if (this.state.selectedIdsStack.length) {
                            const id = this.state.selectedIdsStack[0]
                            if (!this.state.selectedRowsMap[id]) {
                                const cloneArr = utils.cloneArray(this.state.selectedIdsStack)
                                let selectedId = cloneArr.shift()
                                let found = false
                                while (!this.state.selectedRowsMap[selectedId] && !utils.isEmpty(cloneArr)) {
                                    if (this.state.selectedRowsMap[selectedId]) {
                                        selectedMap[selectedId] = true
                                        found = true
                                        break
                                    }
                                    selectedId = cloneArr.shift()
                                }
                                if (!found) {
                                    let isDirectionUp = this.isRowSelectedWithShiftKeyDirectionUp(id, idValue)

                                    // Qui `(this.currentPageSelectedRowsCount() > 0)` è true, quindi ho sempre almeno un range
                                    // dentro a `currentPageSelectedRanges`.
                                    let idOfRange
                                    if (!isDirectionUp) {
                                        idOfRange = currentPageSelectedRanges[currentPageSelectedRanges.length - 1].to
                                    }
                                    else {
                                        idOfRange = currentPageSelectedRanges[0].from
                                    }
                                    isDirectionUp = this.isRowSelectedWithShiftKeyDirectionUp(idOfRange, idValue)
                                    rowRangeIds = this.rowRangeIds(isDirectionUp, idOfRange, idValue)
                                    for (const rangeId of rowRangeIds) {
                                        selectedMap[rangeId] = true
                                    }
                                }
                            }
                            else {
                                let isDirectionUp = this.isRowSelectedWithShiftKeyDirectionUp(id, idValue)
                                rowRangeIds = this.rowRangeIds(isDirectionUp, id, idValue)

                                for (const rangeId of rowRangeIds) {
                                    selectedMap[rangeId] = true
                                }
                            }
                        }
                        else {
                            forceCurrentValueAppendToSelectedIdsStack = true
                            selectedMap[idValue] = true
                        }
                    }
                }
                else {
                    if (previousRowSelected) {
                        for (const rangeId of rowRangeIds) {
                            selectedMap[rangeId] = false
                        }
                    }
                    else {
                        // Non può verificarsi perché una se ho deselezionato una casella ho un range per forza di cose
                        // quindi a priori sarei entrato nella if `if (range) {` sopra.
                    }
                }
            }

            nextState = {
                ...nextState,
                selectedRowsMap: {
                    ...(this.state.selectedRowsMap),
                    ...selectedMap,
                },
                lastToggledId: idValue,
            }
        }
        else {
            if (utils.isEmpty(this.state.selectedIdsStack) && checked) {
                forceCurrentValueAppendToSelectedIdsStack = true
            }
            nextState = {
                ...nextState,
                selectedRowsMap: {
                    ...(this.state.selectedRowsMap),
                    [rowInfo.original[idField]]: checked,
                }
            }
        }

        nextState.currentPageSelectedRanges = []

        if ((checked && !e.shiftKey) || forceCurrentValueAppendToSelectedIdsStack) {
            nextState.selectedIdsStack = utils.cloneArray(this.state.selectedIdsStack)
            nextState.selectedIdsStack.unshift(idValue)
        }
        console.log('onChangeSelectedRow1');
        this.setState(nextState, () => {
            if (this.selectedRowsCount() <= 0) {
                console.log('onChangeSelectedRow2');
                this.setState({
                    lastToggledId: null,
                    selectedIdsStack: []
                }, this.onSelectedRowsMapChangedCallback)
            }
            else {
                this.onSelectedRowsMapChangedCallback()
            }
        })
    }

    componentDidMount() {
        if (this.props.selectableRows) {
            $(document).on('mousedown', '.rt-tbody .rt-tr-group', function (e) { if (e.shiftKey) { e.preventDefault(); } });
        }
    }

    componentWillReceiveProps(nextProps) {
        
        const { data } = nextProps
        const idField = this.getIdField()

        console.log('componentWillReceiveProps nextProps=',nextProps);

        if (this.state.triggeringOnChangeSelectedItemsListener) {

            console.log('componentWillReceiveProps');            
            this.setState({
                triggeringOnChangeSelectedItemsListener: false
            })
            return
        }

        const currentPageIds = []
        for (const row of data) {
            currentPageIds.push(row[idField])
        }

        let nextState = {
            currentPageIds
        }

        const selectedRowsMap = {}
        if (nextProps.selectableRows) {
            if (nextProps.items_all_no_limit) {
                const allFilteredItemsNoLimit = nextProps.items_all_no_limit

                nextState.allFilteredItemsNoLimit = allFilteredItemsNoLimit
                for (const item of allFilteredItemsNoLimit) {
                    selectedRowsMap[item[idField]] = this.state.selectedRowsMap[item[idField]] || this.state.allFilteredChecked || false
                }
            }
            else {
                console.log('MMMM...!!!!')
            }
        }
        nextState.selectedRowsMap = selectedRowsMap

        let nextStateCallback = () => {
            // this.onSelectedRowsMapChangedCallback()
        }

        if (!utils.deepObjectCompare(this.state.filtered, this.state.onFilteredChangeFiltered)) {
            nextState.filtersAreOutOfSync = true
            if (this.state.rerenderingJustTriggered) {
                const filtersObj = utils.cloneDeeply(this.state.filtersObj)
                filtersObj.filtered = utils.cloneDeeply(this.state.onFilteredChangeFiltered)
                nextStateCallback = () => {
                    this.onSelectedRowsMapChangedCallback(() => {
                        console.log('componentWillReceiveProps2');            
                        this.setState({
                            filtered: filtersObj.filtered,
                            rerenderingJustTriggered: false
                        }, () => {
                            const filters = this.buildFilters(filtersObj, this.props.AJAXAdapter)
                            this.performDataFetching(filters)
                        })
                    })
                }
            }
        }
        else {
            nextState.filtersAreOutOfSync = false
            nextState.rerenderingJustTriggered = null
        }

        

        if (nextProps.filtered_count){
            nextState.filtered_count = nextProps.filtered_count;
        }
        if (nextProps.pages){
            nextState.pages = nextProps.pages;
        }
        if (nextProps.limit){
            nextState.limit = nextProps.limit;
        }

        console.log('componentWillReceiveProps3 nextState=',nextState);                    
        this.setState(nextState, nextStateCallback)
    }

    selectCurrentPageChecked() {
        if (utils.isEmpty(this.state.currentPageIds)) {
            return false
        }
        const { currentPageIds } = this.state
        let allChecked = true
        for (let id of currentPageIds) {
            if (!this.state.selectedRowsMap[id]) {
                allChecked = false
            }
        }
        return allChecked
    }

    currentPageSelectedRowsCount() {
        let count = 0
        const { currentPageIds } = this.state
        for (let id of currentPageIds) {
            if (this.state.selectedRowsMap[id]) {
                count++
            }
        }
        return count
    }

    areAllCurrentlyFilteredRowsSelected() {
        return this.props.filtered_count == (this.selectedRowsCount())
    }

    selectedIds() {
        return Object.keys(this.state.selectedRowsMap).filter((key) => this.state.selectedRowsMap[key])
    }

    selectedRowsCount() {
        const count = (this.selectedIds()).length
        return count
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextState.filtersAreOutOfSync) {
            if (nextState.rerenderingJustTriggered === null) {
                console.log('shouldComponentUpdate');
                this.setState({
                    rerenderingJustTriggered: true
                })
            }
            return false
        }
        return true
    }

    render() {

        const { loading, data, t } = this.props
        // console.log('render',this.state);

        let filtered_count = this.state.filtered_count
        let pages = this.state.pages || 1
        let limit = this.state.limit || 10

        const TableRecordsTotal = (props) => {
            let ret = null;
            ret = (
                <ClearfixChildren style={{
                    visibility: filtered_count > 0 && !loading ? 'visible' : 'hidden'
                }}>
                    {
                        (this.props.selectableRows && (
                            <div className="pull-left">
                                <h5 className={props.titleClassName ? props.titleClassName : "custom-no-margin"}>
                                    <small>Record selezionati: {this.selectedRowsCount()}</small>
                                </h5>
                                {
                                    props.showSelectAllCurrentlyFilteredRowsCheckbox
                                    &&
                                    (
                                        <FormGroup check>
                                            <Label check>
                                                <Input type="checkbox"
                                                    checked={this.areAllCurrentlyFilteredRowsSelected()}
                                                    onChange={this.onChangeAllCurrentlyFilteredRowsSelected}
                                                />
                                                <span className="form-check-sign" />
                                                {"Seleziona tutti i record correntemente filtrati"}
                                            </Label>
                                        </FormGroup>
                                    )
                                }
                            </div>
                        ))
                        ||
                        null
                    }
                    <div className="pull-right">
                        <h5 className={props.titleClassName ? props.titleClassName : "custom-no-margin"}>
                            <small>{t("Totale")}: {filtered_count}</small>
                        </h5>
                    </div>
                </ClearfixChildren>
            );
            return ret;
        };

        let propsToExpand = {}
        if (this.props.rerenderKey) {
            propsToExpand.key = this.props.rerenderKey
        }
        const columns = this.props.columns
        if (this.props.selectableRows) {
            propsToExpand.getTrProps = this.getTrProps
            utils.unshiftArray(columns, {
                Header: "",
                Filter: ({ filter, onChange }) => (
                    !loading
                    &&
                    filtered_count > 0
                    &&
                    <FormGroup check className="custom-react-ajax-table-checkbox">
                        <Label check>
                            <Input type="checkbox"
                                checked={this.selectCurrentPageChecked()}
                                onChange={this.onChangeCurrentPageRowsSelected}
                            />
                            <span className="form-check-sign" />
                        </Label>
                    </FormGroup>
                ),
                accessor: "checkbox",
                sortable: false,
                resizable: false,
                width: 50,
                Cell: (row) => {
                    return (
                        <FormGroup check className="custom-react-ajax-table-checkbox">
                            <Label check>
                                <Input type="checkbox"
                                    checked={!!this.isRowSelected(row)}
                                    onClick={e => { e.stopPropagation(); return false; }}
                                    onChange={(e) => {
                                        this.onChangeSelectedRow(e, row)
                                    }}
                                />
                                <span className={"form-check-sign" + (this.isRowSelected(row) ? " custom-checkbox-calcato" : "")} />
                            </Label>
                        </FormGroup>
                    )
                }
            })
        }

        return (<div>
            {this.props.topComponent || null}
            <TableRecordsTotal showSelectAllCurrentlyFilteredRowsCheckbox />
            <ReactTable
                {...propsToExpand}
                data={data}
                loading={loading}
                manual
                filterable
                onFetchData={this.onFetchData}
                columns={this.props.columns}
                pages={pages}
                defaultPageSize={limit}
                showPaginationTop={false}
                showPaginationBottom={true}
                className="-striped -highlight"
                previousText={t('Precedente')}
                nextText={t("Successiva")}
                noDataText={loading ? '' : this.props.noRecordText}
                pageText={t("Pagina")}
                ofText={t("di")}
                rowsText= {t("righe")}
                LoadingComponent={
                    () => {
                        if (loading) {
                            return (
                                <div className="-loading -active">
                                    <div className="-loading-inner custom-margin-0-auto">
                                        <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                    </div>
                                </div>
                            );
                        }
                        else {
                            return null;
                        }
                    }
                }
                onFilteredChange={(filtered, col) => {

                    console.log('onFilteredChange');
                    this.setState({
                        onFilteredChangeFiltered: filtered
                    })
                }}
            />
            <TableRecordsTotal titleClassName="custom-margin-top-bottom-15" />
            {this.props.footerComponent}
        </div>);
    }

}



export default ReactAJAXTable = withTranslation()(ReactAJAXTable);


// WEBPACK FOOTER //
// ./src/components/ReactAJAXTable/ReactAJAXTable.jsx